const { createContext, useContext } = require("react");

const Context = createContext(null);

export default Context;